import { AppBundle } from 'api/optimalprint-sdk.d';
import React from 'react';
import { useDispatch } from 'react-redux';
import updateFilterAttributeOptionOperation from 'store/category/operation/updateFilterAttributeOptionOperation';
import { FilterAttributeGroup } from 'store/category/types';
import OpColorOption from 'components/Common/op-ui-wrappers/OpColorOption/OpColorOption';
import gtmSendEvent from 'utils/gtm/gtmSendEvent';
import gtmFilterSelectEvent from 'utils/gtm/gtmFilterSelectEvent';
import styles from './ColorOptions.module.scss';

export interface OwnProps {}

export interface Props extends OwnProps {
  attribute: AppBundle.Api.Response.Category.V3.CategoryDesignsListV3Response.Filters.IFilterItem;
  group: FilterAttributeGroup;
  onClick?: () => void;
}

const ColorOptions = ({ attribute, group, onClick }: Props) => {
  const dispatch = useDispatch();
  const setFilterOption = async (
    option: AppBundle.Api.Response.Category.V3.CategoryDesignsListV3Response.Filters.IFilterOption,
  ) => {
    if (!option.isAvailable) return;
    gtmSendEvent(gtmFilterSelectEvent(attribute.typeName, option.value));
    dispatch(updateFilterAttributeOptionOperation(group, attribute.typeName, option.value));
    onClick && onClick();
  };

  const capitilizeFirstLetter = (name: string) => {
    if (!name) return '';
    return name.charAt(0).toUpperCase() + name.slice(1);
  };

  return (
    <div className={styles.colourOptions}>
      {attribute.options?.map((option) => (
        <OpColorOption
          key={option.value}
          size="small"
          color={option.hexColor || ''}
          selected={option.isSelected}
          disabled={!option.isAvailable}
          label={capitilizeFirstLetter(option.name)}
          showLabel
          onClick={() => setFilterOption(option)}
        />
      ))}
    </div>
  );
};

export default ColorOptions;
